import { useEffect, useState } from "react";
import { modelStatLimits } from "../../../utils/supplementalData";
import { convertNumberToDecimal, getConformalValue, getStatsCellColor } from "../../../utils/formattingFns";


export default function StatsValue({
    name,
    value,
    statsType,
    threshold,
}: {
    name: string,
    value: string,
    statsType: 'model' | 'prediction',
    threshold?: number,
}) {
    const [ color, setColor ] = useState('#E0E0E0');
    const [ valueLabel, setValueLabel ] = useState('');

    useEffect(() => {
            if (statsType === 'model') {
                const modelLimit = modelStatLimits.find(stat => stat.value === name);
                if (modelLimit) {
                    setColor(getStatsCellColor({ min: modelLimit.min, max: modelLimit.max }, Number(value), false));
                } else {
                    setColor('#E0E0E0');
                } 
            } else {
                if (threshold !== null && threshold !== undefined && typeof value !== 'number') {
                    const numArr = Array.isArray(value) ? value : value.split(',').map(val => Number(val));
                    const { color, label } = getConformalValue(numArr, threshold);
                    setColor(color);
                    setValueLabel(label);
                } else {
                    setColor(getStatsCellColor({ min: 0, max: 1 }, Number(value), false));
                }
                
            }
            
        }, [name, value, statsType, threshold]);


    return (
        <div style={{backgroundColor: color}} className="flex justify-center items-center gap-2 py-1 px-3 text-default font-semibold text-[12px] rounded-lg">
           {threshold !== null && threshold !== undefined && valueLabel ? (
                valueLabel
            ) : (
                convertNumberToDecimal(value)
            )}
        </div>
    )
}